exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts table td .fa.big-icon{display:flex;align-items:center;justify-content:center}.contacts table td .fa.big-icon .svg{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./assets/stylesheets/pages/contacts.scss
// module id = 155
// module chunks = 6